/**
 * Entry point. Importing the components registers their custom elements,
 * which upgrades the ones already in the page; the app then wires them up.
 */

import { App } from "./app.js";
import "./components/game-table.js";
import "./components/profile-dialog.js";
import "./components/saloon-landing.js";
import "./components/table-lobby.js";

function find<K extends keyof HTMLElementTagNameMap>(tag: K, id: string): HTMLElementTagNameMap[K] {
    const element = document.getElementById(id);

    if (element === null || element.localName !== tag) {
        throw new Error(`The page is missing <${tag} id="${id}">`);
    }

    return element as HTMLElementTagNameMap[K];
}

const app = new App({
    banner: find("div", "connection-banner"),
    bannerMessage: find("p", "connection-message"),
    bannerAction: find("button", "connection-action"),
    loading: find("p", "loading"),
    landing: find("saloon-landing", "landing"),
    table: find("game-table", "table"),
    profileDialog: find("profile-dialog", "profile-dialog"),
    lobby: find("table-lobby", "table-lobby")
});

void app.start();
